const RewardList = ({ children }) => (
  <ul className="list-unstyled">{children}</ul>
);

export default RewardList;
